import React from 'react'
import { Link } from 'react-router-dom'

const Propose = ({styles}) => {
  return (
        <Link to={"/governance/propose"} className={styles.governancePropose}>Propose</Link>
  )
}

export default Propose